import { HoursCalculationLoading } from '@/views/admin-hours-calculation';

export default HoursCalculationLoading;
